import { PageId } from '@shared/protos/routes';
import { useState } from 'react';
import { HelpMenuPopup } from './HelpMenuPopup';
import { MobileNavBarButton } from './MobileNavBarButton';

export default function HelpMenuNavItem() {
  const [helpMenuAnchorEl, setHelpMenuAnchorEl] = useState<HTMLButtonElement | null>(null);
  const openHelpMenuPopover = Boolean(helpMenuAnchorEl);
  const helpMenuPopoverId = openHelpMenuPopover ? 'help-menu-popover' : undefined;

  const handleOpenHelpMenu = (event: React.MouseEvent<HTMLButtonElement>) => setHelpMenuAnchorEl(event.currentTarget);

  const handleCloseHelpMenu = () => setHelpMenuAnchorEl(null);

  return (
    <>
      <MobileNavBarButton
        onClick={handleOpenHelpMenu}
        icon="ri-question-line"
        label="Help"
        pageId={PageId.help}
        data-testid="help-menu-nav-item-mobile"
      />
      <HelpMenuPopup id={helpMenuPopoverId} anchorEl={helpMenuAnchorEl} open={openHelpMenuPopover} onClose={handleCloseHelpMenu} />
    </>
  );
}
